import '~/modules/GameEvents/eventListeners';
import '~/modules/RemoteMic/eventListeners';
import '~/modules/Stats';
import '~/modules/utils/array-at-polyfill';
import '~/modules/utils/array-findLastIndex-polyfill';
import '~/modules/utils/exposeSingletons';
import '~/modules/utils/wdyr';

import { renderReactApp } from '~/apps/shared/renderReactApp';
import createKaraokeAnonymousUserName from '~/apps/karaoke/createKaraokeAnonymousUserName';

import CombinedApp from './CombinedApp';

renderReactApp(CombinedApp, {
  createAnonymousUserName: createKaraokeAnonymousUserName,
});
